import { createFileRoute, redirect } from '@tanstack/react-router';

// /trial/:platform/enrichment (no id) is no longer a valid URL.
// Redirect users who land here to catalog-operations.
export const Route = createFileRoute('/_authenticated/_tenant/trial/$platform/enrichment/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/catalog-operations' });
  },
  component: () => null,
});
